import {addEvent} from '../add-event'

export function viewPageEvent(): boolean {
    return addEvent('viewLoginPage', {})
}
